import React from 'react'
import { ModalBody } from 'reactstrap'
import { ConfirmFooter } from '@/dialogs/common/confirmFooter'
import { BasicHeader } from '@/dialogs/common/basicHeader'

import ReportTemplateSelectorContent from '@/components/reporting/reportTemplateSelector/content'

class ReportTemplateSelectorDialog extends React.Component {
  constructor (props, context) {
    super(props, context)

    this.state = {
      selectedTemplates: props.selectedTemplates
    }
  }
  handleChange = selectedTemplates => this.setState({ selectedTemplates })
  render () {
    return (
      <React.Fragment>
        <BasicHeader title='Reporting.ReportingTemplates' {...this.props} />
        <ModalBody>
          <ReportTemplateSelectorContent items={this.props.items} selectedTemplates={this.state.selectedTemplates} onChange={this.handleChange} />
        </ModalBody>
        <ConfirmFooter primaryButtonText='Common.OK' icon='check' {...this.props} onAction={() => this.props.onAction(this.state.selectedTemplates)} />
      </React.Fragment>
    )
  }
}

export default {
  component: ReportTemplateSelectorDialog
}



// WEBPACK FOOTER //
// ./src/dialogs/reportTemplateSelector.js